import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { filterErrorHandler } from '../../hoc/Shared/utility';
import Button from "../../components/Button/Button";

import * as actions from '../../store/ducks/slotFreeSpin/actions';

class SlotFreeSpinShow extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state =
        {
            data: [],
            gameList: [],
            loading: true,
        };
    }

    componentDidMount() 
    {
        if (this.props.selectId) 
        {
            const data = {};
            data.id = this.props.selectId;
            this.props.funcShow(data);
        }
    }

    shouldComponentUpdate(nextProps, nextState) 
    {
        if(nextProps.show !== undefined && nextProps.show !== this.props.show)
        {
            if(nextProps.show.responseCode === 200 && nextProps.show.msgType === "success")
            {
                this.setState({
                    loading: false,
                    data: nextProps.show.data.result,
                    gameList: nextProps.show.data.game_list,
                });
            }
            else 
            {
                this.setState({
                    loading: false,
                    data: [],
                    gameList: []
                }, () => {
                    filterErrorHandler(nextProps.show.message);
                });
            }
        }
        return true;
    }

    render() 
    {
        // console.log(this.state.gameList);
        const { t } = this.props;
        let data = this.state.data;
        let gameList = this.state.gameList;

        return (
            <Auxiliary>
                <div className='breadcrumb-header'>
                    <div className='d-flex'>
                        <div className='my-auto'>
                            <Button typeButton='button' classValue='btn btn-back-outline' idValue='back' buttonName={<i className="angle fe fe-chevron-left"></i>} clicked={() => this.props.changePageHandler('listing')} />
                        </div>
                    </div>
                    <div className='my-auto'>
                        <div className='d-flex'>
                            <h4 className='content-title mb-0 my-auto ml-2'>{t("side-bar.slot_free_spin")}</h4>
                        </div>
                    </div>
                </div>
                <div className='row row-sm'>
                    <div className='col-lg-12 col-xl-12'>
                        <div className='card box-shadow-0'>
                            <div className='card-header'>
                                <h4 className='card-title mg-b-0'>{t('slot-free-spin.free-spin-details')}</h4>
                            </div>
                            <div className='card-body pt-0'>
                                {this.state.loading
                                ?
                                    <Skeleton count={3} />
                                :
                                    <table className='table table-bordered table-hover table-striped'>
                                        <tbody>
                                            <tr>
                                                <th style={{ width: '150px' }}>{t('global.id')}</th>
                                                <td>{data.id}</td>
                                            </tr>
                                            <tr>
                                                <th>{t('slot-free-spin.game-vendor')}</th>
                                                <td><b>({t(`vendor.${data.vendor}`)})</b></td>
                                            </tr>
                                            <tr>
                                                <th>{t('slot-free-spin.reference-code')}</th>
                                                <td>{data.reference_code}</td>
                                            </tr>
                                            <tr>
                                                <th>{t('slot-free-spin.free-round')}</th>
                                                <td>{data.free_round}</td>
                                            </tr>
                                            <tr>
                                                <th>{t('slot-free-spin.bet-scale')}</th>
                                                <td>{data.bet_scale}</td>
                                            </tr>
                                            <tr>
                                                <th>{t('global.created-time')}</th>
                                                <td>{data.create_date}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                    </div>

                    <div className='col-lg-12 col-xl-12'>
                        <div className='card box-shadow-0'>
                            <div className='card-header'>
                                <h4 className='card-title mg-b-0'>{t('game-list.game-list')}</h4>
                            </div>
                            <div className='card-body pt-0'>
                                {this.state.loading
                                ?
                                    <Skeleton count={3} />
                                :        
                                    <ul id='tree1' className='tree'>
                                        <li>
                                        {
                                            gameList.map((val, idx) => 
                                            {
                                                return (
                                                    // <li key={idx}>
                                                        <><i className='fa fa-circle-notch fa-xs'></i> {val.gameName} &nbsp;</>
                                                    // </li>
                                                );
                                            })
                                        }
                                        </li>
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = state => 
{
    return {
        show: state.slotFreeSpin.show,
    }
};

//Using the redux calling api methods
const mapDispatchToProps = dispatch => 
{
    return {
        funcShow: (filter) => dispatch(actions.show(filter)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(SlotFreeSpinShow));